import { Popover } from "./Popover";
import type { PopoverProps } from "./Popover.d";

export { Popover };
export type { PopoverProps };
